import Vue from 'vue'
import VueI18n from 'vue-i18n'

import fr from 'vuetify/lib/locale/fr'
import en from 'vuetify/lib/locale/en'
import localeEn from '@/locales/en.json'
import localeFr from '@/locales/fr.json'

// Si localStorage.getItem('APP_LANG_KEY') est undefined
const language = localStorage.getItem('APP_LANG_KEY') ? localStorage.getItem('APP_LANG_KEY') : process.env.VUE_APP_I18N_LOCALE
localStorage.setItem('APP_LANG_KEY', language)

Vue.use(VueI18n)

const messages = {
  en: {
    ...localeEn,
    $vuetify: en,
  },
  fr: {
    ...localeFr,
    $vuetify: fr,
  },
}

export default new VueI18n({
  locale: localStorage.getItem('APP_LANG_KEY') || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: localStorage.getItem('APP_LANG_KEY') || process.env.VUE_APP_I18N_LOCALE,
  messages,
})
